import { FilterGroup, FilterGroupFilters } from '@helios/common-api'
import { Subject } from 'rxjs'

export interface FilterGroupUpdate extends Partial<FilterGroup> {
  //updatable fields
  name?: string
  description?: string
  filterGroup?: FilterGroupFilters
}

/**
 * Must be an abstract class due to angular injection.
 */
export abstract class FilterGroupService {
  abstract filterGroupAdditions: Subject<FilterGroup>

  abstract getFilterGroups(gridKey: string): Promise<FilterGroup[]>

  abstract getFilterGroup(
    filterGroupId: string,
  ): Promise<FilterGroup | undefined>

  abstract updateFilterGroup(
    filterGroupId: string,
    update: FilterGroupUpdate,
  ): Promise<void>

  /**
   * returns filterGroupPrefix of new FilterGroup
   *
   */
  abstract createFilterGroup(
    gridKey: string,
    name: string,
    description: string,
    filters: FilterGroupFilters,
  ): Promise<string>

  /**
   * returns filterGroupPrefix of new FilterGroup
   *
   * @param filterGroupPrefix
   */
  abstract cloneFilterGroup(
    filterGroupId: string,
    newName: string,
    newDescription: string,
  ): Promise<string | undefined>

  abstract deleteFilterGroup(filterGroupId: string): Promise<void>
}
